import { useQueryClient } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { io } from 'socket.io-client';
import { apiOrigin, tokenStore } from './api';

/**
 * Tempo real do chat (DC3, Q9): conecta no namespace `/realtime` da API com o
 * mesmo JWT e, a cada evento, invalida as consultas do chat — os dados vêm
 * pela API, já com o escopo de quem está logado.
 */
export function useChatRealtime(): boolean {
  const queryClient = useQueryClient();
  const [online, setOnline] = useState(false);

  useEffect(() => {
    const origin = apiOrigin();
    const socket = io(`${origin}/realtime`, {
      auth: (callback) => callback({ token: tokenStore.access ?? '' }),
      transports: ['websocket'],
    });
    const refresh = (payload: { conversationId?: string }) => {
      queryClient.invalidateQueries({ queryKey: ['chat', 'list'] });
      queryClient.invalidateQueries({ queryKey: ['dashboard', 'multiservice'] });
      if (payload?.conversationId) {
        queryClient.invalidateQueries({
          queryKey: ['chat', 'conversation', payload.conversationId],
        });
        queryClient.invalidateQueries({
          queryKey: ['chat', 'messages', payload.conversationId],
        });
      }
    };
    socket.on('ready', () => setOnline(true));
    socket.on('disconnect', () => setOnline(false));
    socket.on('conversation.updated', refresh);
    socket.on('message.created', refresh);
    socket.on('message.updated', refresh);
    return () => {
      socket.disconnect();
    };
  }, [queryClient]);

  return online;
}
